import React from "react";
import useAuth from "../../Hooks/useAuth";
import ActionTop from "../common/ActionTop";
import LoadMore from "../common/LoadMore";
import User from "./User";

const AutorsList = () => {
  const {data} = useAuth()
  return (
    <section className="autorslist">
      <div className="container">
        <div className="autors-top">
          <h2 className="pageTitle">
            Autho<span>rs</span>
          </h2>
          <div className="autors-action">
            <ActionTop />
          </div>
        </div>
        <div className="autors-items">
          {data.map((authorsItem,i) => {
            return (
              <div className="autors-item" key={authorsItem?.id}>
                <div className="autors-item-img">
                  <img
                    src={require(`${process.env.REACT_APP_AUTHORS_IMAGE}${authorsItem?.cover}`)}
                    alt={authorsItem?.profileImg}
                  />
                  <div className="autors-item-user">
                  <User
                      pic={require(`${process.env.REACT_APP_USER_IMAGE}${authorsItem?.profileImg}`)} alt={''}
                      status={authorsItem?.status}
                      id={authorsItem?.id}
                  />
                  </div>
                </div>
                <div className="autors-item-content">
                  <h4 className="autors-item-title">{authorsItem?.profileName}</h4>
                  <span className="autors-item-address">{authorsItem?.address}</span>
                  <p className="autors-item-pre">{authorsItem?.description}</p>
                  <div className="autors-item-btm">
                    <div className="autors-item-btm-left">
                      <span>{authorsItem?.follower}</span>
                      <small>Followers</small>
                    </div>
                    <button className="autors-item-btn">Follow</button>
                    
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <LoadMore btnTitle="Load more Autors" />
      </div>
    </section>
  );
};

export default AutorsList;
